import { render, staticRenderFns } from "./Dagre.vue?vue&type=template&id=35b5255e&"
import script from "./Dagre.vue?vue&type=script&lang=ts&"
export * from "./Dagre.vue?vue&type=script&lang=ts&"
import style0 from "./Dagre.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports